export const QA_NAME_INSURANCE_ITEM_BTN = 'insurance'

export const QA_NAME_DELETE_INSURANCE_ITEM_BTN = 'deleteInsurance'
